import { HeartHandshake } from "lucide-react";
import { PageHeader } from "@/components/site/PageHeader";
import { Reveal } from "@/components/site/Reveal";
import { QuoteForm } from "@/components/site/QuoteForm";
import { LIFE_OPTIONS, CONTACT } from "@/data";

export default function LifeInsurancePage() {
  return (
    <>
      <PageHeader
        overline="Life Insurance"
        title="Love, made"
        accent="permanent."
        subtitle="Coverage built to replace income, cover final expenses, and leave a tax-free legacy for the people who matter most."
      />

      <section className="relative py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {LIFE_OPTIONS.map((o, i) => (
              <Reveal key={o.name} delay={(i % 2) * 0.06}>
                <div
                  data-testid={`life-option-${i}`}
                  className="group h-full rounded-3xl border border-white/10 bg-[#0a192f] p-8 transition-colors duration-500 hover:border-[#bf953f]/40"
                >
                  <span className="font-serif-display text-sm text-[#d4af37]">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="mt-3 font-serif-display text-2xl md:text-3xl text-white">{o.name}</h3>
                  <p className="mt-3 font-body font-light text-sm md:text-base leading-relaxed text-white/60">{o.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <QuoteForm />

      <section className="relative py-20 md:py-28 bg-[#0a192f] border-t border-[#bf953f]/10">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <Reveal>
            <HeartHandshake size={44} className="mx-auto text-[#d4af37]" strokeWidth={1.5} />
            <h2 className="mt-6 font-serif-display text-4xl sm:text-5xl md:text-6xl font-medium tracking-tight text-white">
              Prefer to talk it <span className="text-gold-gradient italic">through?</span>
            </h2>
            <p className="mt-5 mx-auto max-w-xl font-body font-light text-base md:text-lg text-white/60">
              Every household is different. We'll review your income, mortgage, and goals — then match you with
              the right coverage at the right price. No pressure, ever.
            </p>
            <div className="mt-10 flex flex-wrap justify-center gap-4">
              <a
                href={CONTACT.phoneHref}
                data-testid="life-call-btn"
                className="btn-sweep inline-flex items-center rounded-full bg-gold-metallic px-8 py-3.5 font-body text-sm font-medium tracking-wide text-black"
              >
                Call Us — {CONTACT.phone}
              </a>
              <a
                href={CONTACT.emailHref}
                data-testid="life-email-btn"
                className="inline-flex items-center rounded-full border border-[#bf953f]/40 px-8 py-3.5 font-body text-sm tracking-wide text-white/80 hover:text-[#fcf6ba] hover:border-[#d4af37] transition-colors duration-300"
              >
                Email the Agency
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
